/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import CloseIcon from "@mui/icons-material/Close";
import { Dialog } from "@mui/material";
import cn from "classnames";

const CreateDialog = (props) => {

    const {
        open,
        onClose,
        title,
        subTitle,
        children,
        fullWidth,
        className,
        size = "small",
        ...moreProps
    } = props;

    const dialogClassNames = cn(
        "common-dialog",
        className,
        {
            fullWidth,
            // this will set the size only if fullWidth is not specified
            // e.g. (if size === 'medium' and fullWidth is false, then 'medium' will be added)
            [size]: size && !fullWidth
        },
    );

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby='create-dialog-title'
            aria-describedby='create-dialog-description'
            fullWidth
            className={dialogClassNames}
            {...moreProps}
        >
            <div className='common-dialog-title'>
                <div className="common-dialog-title-top">
                    <div className="common-dialog-title-title">
                        {title}
                    </div>
                </div>
                <div className="common-dialog-title-icon">
                    <CloseIcon
                        className="common-dialog-title-closeButton"
                        aria-label="close"
                        onClick={onClose}
                    />
                </div>
            </div>
            {subTitle &&
                <div
                    className='common-dialog-title-subtitle'
                    dangerouslySetInnerHTML={{
                        __html: subTitle,
                    }}
                ></div>
            }
            {/*<DialogContent id='alert-dialog-description'>*/}
            {/*<DialogContent>*/}
            {children}
            {/*</DialogContent>*/}
        </Dialog>
    );
};

CreateDialog.displayName = "CreateDialog";
export { CreateDialog };
